import styles from "./collections.module.css";
import { HeadingTitle } from "../shared/index";
import CollectionItem from "./CollectionItem/CollectionItem";

const Collections = ({ categories }) => {
  return (
    <section className={styles.collection__wrapper}>
      <HeadingTitle
        style={styles.heading}
        text="Our Categories"
      />

      <div className={styles.categories__grid}>
        {categories.map((item) => (
          <CollectionItem
            key={item.id}
            category={item}
          />
        ))}
      </div>
    </section>
  );
};

export default Collections;